import { createRecurringConfig, updateRecurringConfig } from "./api";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateJobQueries } from "components/job/queries";

export function useCreateRecurringConfig() {
  return useMutation({
    mutationFn: async ({ jobId, values }) => {
      return await createRecurringConfig({ jobId, values });
    },
    onSuccess: () => {
      invalidateJobQueries();
      toast.success("Recurring config created successfully");
    },
    onError: (err) => {
      toast.error(err.message || "Failed to create config");
      console.error(err);
    },
  });
}

export function useUpdateRecurringConfig() {
  return useMutation({
    mutationFn: async ({ id, values }) => {
      return await updateRecurringConfig({ id, values });
    },
    onSuccess: () => {
      invalidateJobQueries();
      toast.success("Recurring config updated successfully");
    },
    onError: (err) => {
      toast.error(err.message || "Failed to update config");
      console.error(err);
    },
  });
}
